import { mapContentBlocks, Product, SharingEvent } from '@news-mono/web-common'
import { EventPostV4DTO } from '@west-australian-newspapers/publication-types'
import React, { FC } from 'react'
import { Logger } from 'typescript-log'
import { IconPersonSilhouette, useProduct } from '../../..'
import { ArticleBlockContent } from '../../ArticleBlockContent/ArticleBlockContent'
import {
    StyledLiveEventArticleBlockContent,
    StyledLiveEventAuthor,
    StyledLiveEventAuthorWrapper,
    StyledLiveEventByline,
    StyledLiveEventHeadshot,
    StyledLiveEventIcon,
    StyledLiveEventPost,
    StyledLiveEventSocialIcons,
    StyledLiveEventTimestamp,
    StyledLiveEventTitle,
} from './LiveEventPost.styled'

export interface LiveEventPostProps {
    post: EventPostV4DTO
    eventTitle: string
    log: Logger
    adUnitPath: string
    lazyLoadRef: React.RefObject<HTMLDivElement> | undefined
    onEvent: (event: SharingEvent) => void
}

export const LiveEventPost: FC<LiveEventPostProps> = ({
    post,
    eventTitle,
    log,
    adUnitPath,
    lazyLoadRef,
    onEvent,
}) => {
    const product = useProduct()
    const isSevenNews = product === Product.SevenNews

    const displayHeadshot =
        post.profiles.length === 1 && post.profiles[0]?.thumbnailPhoto

    const authorName =
        post.profiles.length >= 1
            ? post.profiles.map((profile) => profile.name).join(' &')
            : post.byline

    return (
        <StyledLiveEventPost ref={lazyLoadRef} key={post.id} id={post.id}>
            <StyledLiveEventByline>
                {isSevenNews ? (
                    <StyledLiveEventIcon>
                        <IconPersonSilhouette />
                    </StyledLiveEventIcon>
                ) : (
                    displayHeadshot && (
                        <StyledLiveEventHeadshot
                            src={post.profiles[0].thumbnailPhoto}
                        />
                    )
                )}

                <StyledLiveEventAuthorWrapper>
                    <StyledLiveEventTimestamp
                        timestampStyle="relative"
                        time={post.publishedDate}
                    />
                    <StyledLiveEventAuthor>{authorName}</StyledLiveEventAuthor>
                </StyledLiveEventAuthorWrapper>
            </StyledLiveEventByline>
            {post.title && (
                <StyledLiveEventTitle>{post.title}</StyledLiveEventTitle>
            )}
            <StyledLiveEventArticleBlockContent>
                <ArticleBlockContent
                    blocks={mapContentBlocks(post.content.blocks)}
                    onEvent={() => {}}
                    log={log}
                    adUnitPath={adUnitPath}
                    publicationKind={'event'}
                />
            </StyledLiveEventArticleBlockContent>
            <StyledLiveEventSocialIcons
                url={post._self}
                text={post.title || eventTitle}
                onEvent={onEvent}
                shareOptions={['twitter', 'facebook', 'clipboard']}
                customCampaign="liveblog"
                publicationId={post.eventId}
                postId={post.id}
            />
        </StyledLiveEventPost>
    )
}
